<div class="connectors-settings">
  <h2>{{ userContextService.CurrentInstance.Name }}</h2>
  <!-- Display Linked Sources -->
  <app-hot-glue 
    #linkedSources
    [linkedSources]="true">
  </app-hot-glue>

  <!-- Button to open the add-source popup -->
  <div class="add-source-button-container">
    <button (click)="onAddSourceClicked()" class="cta-plus-button">+</button>
  </div>

  <!-- Popup for adding a new source -->
  <div class="popup-overlay" *ngIf="showAddPopup">
    <div class="popup-content">
      <!-- Optionally add a header and a close icon/button -->
      <h3>Add New Source</h3>
      <app-hot-glue 
         #addSource
         [linkedSources]="false"
         (scriptLoaded)="onScriptLoaded()"
      >
      </app-hot-glue>
      <button class="popup-close" (click)="showAddPopup = false">Close</button>
    </div>
  </div>
</div>
